export const CurrentStepIcon = (props) => (
  <svg {...props} width="23" height="23" viewBox="0 0 20 22" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="10.4999" cy="9.99967" r="6.16667" stroke="#2E3860" strokeWidth="6" />
  </svg>
);
